"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GradingStatus = exports.Submission = exports.SubmissionData = void 0;
var http_client_1 = require("./http_client");
var utils_1 = require("./utils");
var SubmissionData = /** @class */ (function () {
    function SubmissionData(args) {
        this.pk = args.pk;
        this.group = args.group;
        this.timestamp = args.timestamp;
        this.submitter = args.submitter;
        this.submitted_filenames = args.submitted_filenames;
        this.discarded_files = args.discarded_files;
        this.missing_files = args.missing_files;
        this.status = args.status;
        this.grading_start_time = args.grading_start_time;
        this.non_deferred_grading_end_time = args.non_deferred_grading_end_time;
        this.is_past_daily_limit = args.is_past_daily_limit;
        this.is_bonus_submission = args.is_bonus_submission;
        this.count_towards_total_limit = args.count_towards_total_limit;
        this.does_not_count_for = args.does_not_count_for;
        this.position_in_queue = args.position_in_queue;
        this.last_modified = args.last_modified;
    }
    return SubmissionData;
}());
exports.SubmissionData = SubmissionData;
var Submission = /** @class */ (function (_super) {
    __extends(Submission, _super);
    function Submission() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Submission.subscribe = function (observer) {
        Submission._subscribers.add(observer);
    };
    Submission.unsubscribe = function (observer) {
        Submission._subscribers.delete(observer);
    };
    Submission.get_all_from_group = function (group_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/groups/" + group_pk + "/submissions/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (data) { return new Submission(data); })];
                }
            });
        });
    };
    Submission.get_final_graded_submission_from_group = function (group_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/groups/" + group_pk + "/ultimate_submission/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new Submission(response.data)];
                }
            });
        });
    };
    Submission.get_all_from_group_with_results = function (group_pk, feedback_category) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/groups/" + group_pk + "/submissions_with_results/";
                        if (feedback_category !== undefined) {
                            url += "?feedback_category=" + feedback_category;
                        }
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    Submission.get_by_pk = function (submission_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/submissions/" + submission_pk + "/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new Submission(response.data)];
                }
            });
        });
    };
    Submission.create = function (group_pk, files, on_upload_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var form_data, files_1, files_1_1, file, response, result;
            var e_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        form_data = new FormData();
                        try {
                            for (files_1 = __values(files), files_1_1 = files_1.next(); !files_1_1.done; files_1_1 = files_1.next()) {
                                file = files_1_1.value;
                                form_data.append('submitted_files', file, file.name);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (files_1_1 && !files_1_1.done && (_a = files_1.return)) _a.call(files_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/groups/" + group_pk + "/submissions/", form_data, { on_upload_progress: on_upload_progress })];
                    case 1:
                        response = _b.sent();
                        result = new Submission(response.data);
                        Submission.notify_submission_created(result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    Submission.notify_submission_created = function (submission) {
        var e_2, _a;
        try {
            for (var _b = __values(Submission._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_submission_created(submission);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    Submission.prototype.get_file_content = function (filename, on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get_file("/submissions/" + this.pk + "/file/?filename=" + filename, { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    Submission.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().patch("/submissions/" + this.pk + "/", utils_1.filter_keys(this, Submission.EDITABLE_FIELDS))];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, response.data);
                        Submission.notify_submission_changed(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    Submission.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var last_modified, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        last_modified = this.last_modified;
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/submissions/" + this.pk + "/")];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, response.data);
                        if (last_modified !== this.last_modified) {
                            Submission.notify_submission_changed(this);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Submission.prototype.remove_from_queue = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/submissions/" + this.pk + "/remove_from_queue/")];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, response.data);
                        Submission.notify_submission_changed(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    Submission.notify_submission_changed = function (submission) {
        var e_3, _a;
        try {
            for (var _b = __values(Submission._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_submission_changed(submission);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    Submission._subscribers = new Set();
    Submission.EDITABLE_FIELDS = [
        'count_towards_total_limit'
    ];
    return Submission;
}(SubmissionData));
exports.Submission = Submission;
var GradingStatus;
(function (GradingStatus) {
    // The submission has been accepted and saved to the database
    GradingStatus["received"] = "received";
    // The submission has been queued is waiting to be graded
    GradingStatus["queued"] = "queued";
    GradingStatus["being_graded"] = "being_graded";
    // Non-deferred test cases have finished and the group can submit
    // again.
    GradingStatus["waiting_for_deferred"] = "waiting_for_deferred";
    // All test cases have finished grading.
    GradingStatus["finished_grading"] = "finished_grading";
    // A student removed their submission from the queue before it
    // started being graded.
    GradingStatus["removed_from_queue"] = "removed_from_queue";
    // The submission was rejected after failing an AGTestSuite
    // setup command where reject_submission_if_setup_fails was true.
    GradingStatus["rejected"] = "rejected";
    // Something unexpected occurred during the grading process.
    GradingStatus["error"] = "error";
})(GradingStatus = exports.GradingStatus || (exports.GradingStatus = {}));
//# sourceMappingURL=submission.js.map